module.exports = "<electra-sub-page-header \t[text]=\"'StateBook'\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t(close)=\"closeClick()\">\n</electra-sub-page-header>\n<iframe [src]=\"currentUrl\" [scrolling]=\"((navigator.userAgent.indexOf('iPhone') !== -1 || navigator.userAgent.indexOf('iPad') !== -1) && cordova === undefined) ? 'no' : 'yes'\">\n</iframe>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/electraLib/component/iab/iab.component.html
// module id = 426
// module chunks = 1